export default {
      id: "ic-game-arrow-right-usage",
      viewBox: "0 0 30 26",
      url: "/" + "images/icons.3.109.2.svg#ic-game-arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }